import { Box, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import styles from "../styles/global-styles";
import MovileDetailInSite from "../components/core/inventory/product-in-site/MovileDetailInSite";
import AccesoryDetailInSite from "../components/core/inventory/product-in-site/AccesoryDetailInSite";
import ChipDetailInSite from "../components/core/inventory/product-in-site/ChipDetailInSite";
import CashCardDetailInSite from "../components/core/inventory/product-in-site/CashCardDetailInSite";

const useStyles = makeStyles(() => ({
  subtitle: styles.subtitle,
  link: styles.link,
}));

const ContainerProductDetailBySite = ({
  location: { state },
  history: { push },
}) => {
  const classes = useStyles();
  const {
    brand,
    model,
    siteId,
    barCode,
    productTypeId,
    lote,
    cardCatalogueId,
  } = state || {};

  const returnToDashboard = () => setTimeout(() => push("/dashboard"), 2000);

  console.log("state", state);
  if (productTypeId) {
    if (
      (productTypeId === 1 || productTypeId === 2) &&
      (!brand || !model || !siteId || !barCode)
    ) {
      returnToDashboard();
    }
    if (productTypeId === 3 && (!lote || !siteId)) {
      console.log("no hay");
      returnToDashboard();
    }
    if (productTypeId === 4 && !cardCatalogueId) {
      returnToDashboard();
    }
  } else {
    returnToDashboard();
  }

  /**TODO arreglar validacion */
  const errorInProductsDetail = () => {
    if (!brand || !model || !lote || !siteId || !productTypeId) {
      return (
        <Typography
          variant="h6"
          component="h4"
          style={{ marginTop: 50 }}
          className={classes.subtitle}
        >
          Error al obtener detalles del producto
        </Typography>
      );
    }
  };

  return (
    <>
      <div style={{ display: "inline-flex" }}>
        <ArrowBackIosIcon color="primary" />
        <Typography variant="body1" component={"div"}>
          <Box mb={3}>
            {" "}
            <Link
              to={
                productTypeId === 1
                  ? "/dashboard/inventario/moviles/sucursal"
                  : productTypeId === 2
                  ? "/dashboard/inventario/accesorios/sucursal"
                  : productTypeId === 3
                  ? "/dashboard/inventario/chips/sucursal"
                  : "/dashboard/inventario/tarjetas-saldo/sucursal"
              }
              className={classes.link}
            >
              Regresar
            </Link>
          </Box>
        </Typography>
      </div>
      {brand && model && siteId && productTypeId === 1 && (
        <MovileDetailInSite
          brand={brand}
          model={model}
          siteId={siteId}
          barCode={barCode}
        />
      )}
      {brand && model && siteId && productTypeId === 2 && (
        <AccesoryDetailInSite
          brand={brand}
          model={model}
          siteId={siteId}
          barCode={barCode}
        />
      )}

      {siteId && productTypeId === 3 && lote && (
        <ChipDetailInSite lote={lote} siteId={siteId} />
      )}

      {cardCatalogueId && siteId && productTypeId === 4 && (
        <CashCardDetailInSite
          cardCatalogueId={cardCatalogueId}
          siteId={siteId}
        />
      )}
    </>
  );
};

export default ContainerProductDetailBySite;
